import React, { useContext, useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router";
import { FaArrowLeft, FaEdit, FaTrash } from "react-icons/fa";
import { CurrentUserContext } from "../../../../App";
import * as adminApi from "../../../../service/adminApi";
import { RedirectCode400 } from "../../../RedirectCode400";

function ViewAnnouncement() {
  const { setIsMessage } = useContext(CurrentUserContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [titlepage, setTitlePage] = useState("");
  const [titleValue, setTitleValue] = useState("");
  const [defaultOption, setDefaultOption] = useState("");

  useEffect(() => {
    if (location.state?.type === "announcement") {
      setTitlePage(location.state?.title || "No Title");
      setTitleValue(location.state?.type || "");
      setDefaultOption("1");
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      navigate("/");
    }
  }, [location, navigate]);

  const formatDate = (date) => {
    const monthsThai = [
      "ม.ค.",
      "ก.พ.",
      "มี.ค.",
      "เม.ย.",
      "พ.ค.",
      "มิ.ย.",
      "ก.ค.",
      "ส.ค.",
      "ก.ย.",
      "ต.ค.",
      "พ.ย.",
      "ธ.ค.",
    ];
    const [year, month, day] = date.split("-");
    const formattedDate = `${parseInt(day)} ${
      monthsThai[parseInt(month) - 1]
    } ${year}`;
    return formattedDate;
  };

  const Picture = (image) => {
    return `
      <div className="flex flex-wrap gap-3 mt-2">
        <div className="relative group">
          <img 
            src=${image}
            alt="illustration" 
            style="width: 120px; height: 120px; object-fit: cover; border-radius: 8px; border: 1px solid #e2e2e4;"
          />
        </div>
      </div>
    `;
  };

  const IllustrationGallery = (images) => {
    if (!images || images.length === 0) return "ไม่มีข้อมูล";
    return (
      <div className="flex flex-wrap gap-3 mt-2">
        {images.map((img, idx) => (
          <div key={idx} className="relative group">
            <img 
              src={img} 
              alt={`illustration-${idx}`} 
              className="w-[120px] h-[120px] object-cover rounded-lg border border-gray-200 shadow-sm"
            />
            <a 
              href={img} 
              target="_blank" 
              rel="noreferrer"
              className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-all rounded-lg"
            />
          </div>
        ))}
      </div>
    );
  };

  const DownloadDocument = (file) => {
    return (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <span style={{ fontSize: "24px" }}>📄</span>
        <a
          href={file}
          download="เอกสาร.pdf"
          style={{ textDecoration: "none", color: "blue" }}
        >
          เอกสาร.pdf
        </a>
      </div>
    );
  };

  let detail = {
    title: "รายละเอียด",
    detail: `${location.state?.detail || "ไม่ระบุ"} ${
      location.state?.lname || "ไม่ระบุ"
    }`,
  };

  if (
    location.state?.category === "announcement" ||
    location.state?.category === "news" ||
    location.state?.category === "article"
  ) {
    detail = {
      title: "รายละเอียด",
      detail: `${location.state?.detail || "ไม่ระบุ"}`,
    };
  }

  const row = [
    {
      title: "รูปภาพ",
      detail: location.state?.image
        ? Picture(location.state?.image)
        : "ไม่มีข้อมูล",
    },
    {
      title: "หมวดหมู่",
      detail: location.state?.category || "ไม่มีข้อมูล",
    },
    {
      title: "หัวข้อ",
      detail: location.state?.title || "ไม่มีข้อมูล",
    },
    {
      title: "ไฟล์เเนบ",
      detail: location.state?.file ? location.state?.file : "ไม่มีข้อมูล",
    },
    {
      title: "ภาพประกอบเพิ่มเติม",
      detail: location.state?.illustration && location.state?.illustration.length > 0
        ? IllustrationGallery(location.state?.illustration)
        : "ไม่มีข้อมูล",
    },
    {
      title: "ลำดับ",
      detail: location.state?.weight || "",
    },
    {
      title: "สร้างโดย",
      detail: `${location.state?.fname} ${location.state?.lname}`,
    },
    {
      title: "วันที่สร้าง",
      detail: formatDate(location.state?.update_date) || "ไม่ระบุ",
    },
    {
      title: "วันที่แก้ไข",
      detail: formatDate(location.state?.update_date) || "ไม่ระบุ",
    },
  ];

  const removeGuideline = async (id) => {
    if (!window.confirm(`คุณต้องการลบ ${location.state?.title} ใช่หรือไม่`)) {
      return;
    }
    let res = await adminApi.removeContent(id);
    if (res) {
      if (res["data"]["code"] === 200) {
        setIsMessage({ type: "success", data: "ลบสำเร็จ" });
        navigate("/admin/management/faq", {
          state: {
            type: "faq",
          },
        });
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
      navigate("/admin/management/press-release", {
        state: {
          type: "announcement",
        },
      });
    }
  };

  return (
    <div>
      <div className="flex flex-row justify-between items-center mb-[10px]">
        <div className="text-3xl md:text-[18px] text-[#747081]">
          {titlepage}
        </div>
        <div className="flex flex-row gap-2">
          <button
            onClick={() =>
              navigate("/admin/management/press-release/", {
                state: {
                  type: "announcement",
                },
              })
            }
            className="flex justify-center items-center h-[30px] p-2 rounded-[5px] cursor-pointer"
            style={{ background: "#FFCC99 0% 0% no-repeat padding-box" }}
          >
            <FaArrowLeft style={{ color: "orange" }} />
          </button>
          <button
            className="flex justify-center items-center h-[30px] p-2 rounded-[5px] cursor-pointer"
            style={{ background: "#AFEBE3 0% 0% no-repeat padding-box" }}
            onClick={() =>
              navigate("/admin/management/press-release/edit-pressrelease", {
                state: {
                  type: "announcement",
                  image: location.state?.image,
                  id: location.state?.id,
                  category: location.state?.category,
                  title: location.state?.title,
                  detail: location.state?.detail,
                  file: location.state?.file,
                  illustration: location.state?.illustration ?? [],
                  pined: location.state?.pined,
                  active: location.state?.active,
                  publishStartDate: location.state?.publishStartDate,
                  publishEndDate: location.state?.publishEndDate,
                },
              })
            }
          >
            <FaEdit style={{ color: "green" }} />
          </button>
          <button
            className="flex justify-center items-center h-[30px] p-2 rounded-[5px] cursor-pointer"
            style={{ background: "#FCD8DB 0% 0% no-repeat padding-box" }}
            onClick={() => removeGuideline(location.state?.id)}
          >
            <FaTrash style={{ color: "red" }} />
          </button>
        </div>
      </div>
      <div className="flex flex-row rounded-[6px] border-[#E2E2E4] border min-w-[400px] md:w-[100%] md:min-w-[300px] p-[9px_16px] w-full">
        <div className="flex flex-col w-full">
          {row.map((item, index) => (
            <div key={index} className="flex flex-row mb-[10px]">
              <div className="w-[20%] sm:w-[30%] font-bold text-[16px] sm:text-[14px]">
                {item.title}
              </div>
              <div className="w-[80%] sm:w-[70%] break-words whitespace-normal text-[16px] sm:text-[14px] text-[#A9A7B1]">
                {item.title === "ไฟล์เเนบ" ? (
                  <>{DownloadDocument(item.detail)}</>
                ) : item.title === "ภาพประกอบเพิ่มเติม" ? (
                  <>{item.detail}</> // แสดง Gallery ตรงๆ เพราะเป็น Component
                ) : (
                  <div dangerouslySetInnerHTML={{ __html: item.detail }} />
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ViewAnnouncement;
